import { Row as RowAntd, Checkbox, Tooltip, Col, Icon, Button, Modal, Popover } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fromQuickSearch } from './../../../../../actions/quickSearchAction';
import { onCheck, clearShipmentFailFeed } from './../../../../../actions/shipmentAction';
import { shipmentStatus, feedTransmitStatus } from './../../../../../constants';
import iconAmazon from './../../../../../resources/imgs/amazon.png';
import { convertDateFromUTC, getMomentFromOrginDate } from './../../../../../services/dst';
import history from './../../../../../services/history';
import { getImageChannel } from './../../../../../constants/order';
import { map } from 'lodash';
import lang from './../../../../../languages/en';
import { alertError, alertWarning, showConfirm } from './../../../../../services/dialog';
import { getPackageInfoByShipmentId } from './../../../../../utils/shipment';

import './styles.css';
import { Fragment } from 'react';

const StatusActiveTrackingLink = [
    shipmentStatus.SHIPPED,
    shipmentStatus.ARRIVED_AT_DESTINATION,
    shipmentStatus.OUT_FOR_DELIVERY,
    shipmentStatus.DELIVERY_DELIVERED
]
const confirm = Modal.confirm;
class Row extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            packages: null,
            loadingPackages: false,
            packageError: null
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.shipments !== this.props.shipments) {
            this.setState({
                expanded: false,
                packages: null,
                loadingPackages: false,
                packageError: null
            });
        }
    }
    toggleExpand = (e) => {
        e.stopPropagation();
        const { shipments, i } = this.props;
        const shipmentID = shipments[i].ShipmentID;
        // Fetch packages if expanding and not loaded
        if (!this.state.expanded && !this.state.packages && !this.state.loadingPackages) {
            this.fetchPackages(shipmentID);
        }

        this.setState({ expanded: !this.state.expanded });
    }

    fetchPackages = async (shipmentID) => {
        this.setState({ loadingPackages: true, packageError: null });

        try {
            const response = await getPackageInfoByShipmentId({ ShipmentIDs: [shipmentID] });
            if (response.data.code === 10001) {
                const packages = response.data.data.PackageInformation || [];
                this.setState({ packages, loadingPackages: false });
            } else {
                this.setState({
                    packageError: 'Failed to load package information',
                    loadingPackages: false
                });
            }
        } catch (error) {
            this.setState({
                packageError: 'Error loading packages',
                loadingPackages: false
            });
        }
    }
    copyToClipboard = str => {
        console.log(`copy ${str} to clipboard`);

        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    detailShipment = (e, package_id, i) => {
        if (e.target.type === 'checkbox'
            || e.target.tagName === 'svg'
            || e.target.tagName === 'path'
            || e.target.getAttribute('name') === 'value'
            || e.target.getAttribute('name') === 'check_shipment'
            || (StatusActiveTrackingLink.includes(this.props.shipments[i]['StatusID'])
                && e.target.name === 'tracking_no')) {

            if (e.target.getAttribute('name') === 'value') {
                this.copyToClipboard(e.target.innerHTML);
            }

            return;
        }

        if (e.type === 'mousedown') {
            this.x = e.pageX;
            this.y = e.pageY;
        }
        if (e.type === 'mouseup' && this.x === e.pageX && this.y === e.pageY && e.button !== 2) {
            history.push('/detail-shipment?package_id=' + package_id)
        }
        if (e.type === 'click', e.button !== 2) {
            history.push('/detail-shipment?package_id=' + package_id)
        }
    }

    renderStatusStatusID = (statusID) => {
        switch (statusID) {
            case shipmentStatus.AWAITING_PACKAGE_INFO:
                return 'Awaiting Package Info'
            case shipmentStatus.READY_TO_PRINT:
                return 'Ready To Print'
            case shipmentStatus.READY_TO_TRANSMIT:
                return 'Ready To Transmit '
            case shipmentStatus.TRANSMITED:
            case shipmentStatus.TRANSMITED_KTE:
            case shipmentStatus.IMPORTED_KTE:
                return 'Shipped'
            case shipmentStatus.SHIPPED:
            case shipmentStatus.ARRIVED_AT_DESTINATION:
            case shipmentStatus.OUT_FOR_DELIVERY:
                return 'In Transit'
            case shipmentStatus.DELIVERY_DELIVERED:
                return 'Delivered'
            case shipmentStatus.PENDING_TRANSMIT:
                return 'Pending Transmit'
            case shipmentStatus.FULFILLMENT_IN_PROCESS:
                return 'Fulfillment In Process'
            case shipmentStatus.SHIPPING_IN_PROCESS:
                return 'Shipping In Process'
            case shipmentStatus.FULFILLMENT_COMPLETED:
                return 'Fulfillment Completed'
            case shipmentStatus.PENDING_SHIPPING_IN_PROCESS:
                return 'Pending Shipping In Process'
            default:
                return ''
        }
    }

    renderStatusShipment = (shipment) => {
        let statusID = shipment.StatusID;
        switch (statusID) {
            case shipmentStatus.AWAITING_PACKAGE_INFO:
                return 'Awaiting Package Info'
            case shipmentStatus.READY_TO_PRINT:
                return 'Ready To Print'
            case shipmentStatus.READY_TO_TRANSMIT:
                return 'Ready To Transmit '
            case shipmentStatus.TRANSMITED:
            case shipmentStatus.TRANSMITED_KTE:
            case shipmentStatus.IMPORTED_KTE:
                if (shipment.FeedTransmitStatus && shipment.FeedTransmitStatus.FeedStatus === feedTransmitStatus.FAIL) {
                    return 'Shipped (Transmission Error)';
                } else {
                    return 'Shipped';
                }
            case shipmentStatus.SHIPPED:
            case shipmentStatus.ARRIVED_AT_DESTINATION:
            case shipmentStatus.OUT_FOR_DELIVERY:
                return 'In Transit'
            case shipmentStatus.DELIVERY_DELIVERED:
                return 'Delivered'
            case shipmentStatus.PENDING_TRANSMIT:
                return 'Pending Transmit'
            case shipmentStatus.FULFILLMENT_IN_PROCESS:
                return 'Fulfillment In Process'
            case shipmentStatus.SHIPPING_IN_PROCESS:
                return 'Shipping In Process'
            case shipmentStatus.FULFILLMENT_COMPLETED:
                return 'Fulfillment Completed'
            case shipmentStatus.PENDING_SHIPPING_IN_PROCESS:
                return 'Pending Shipping In Process'
            default:
                return ''
        }
    }

    renderTrackingHistory = (trackingHistory) => {
        if (trackingHistory && trackingHistory.length > 0) {
            return (
                <div>
                    {map(trackingHistory, item => (
                        <div>
                            <div className='th-item'>
                                {
                                    item.StatusCode === "A0" ?
                                        <div className="th-tracking-date">{convertDateFromUTC(item.TrackingDate).format('MM/DD')}</div>
                                        :
                                        <div className="th-tracking-date">{getMomentFromOrginDate(item.TrackingDate).format('MM/DD')}</div>
                                }

                                <div className="th-status-name">{item.StatusName}</div>
                            </div>
                        </div>


                    ))}
                </div>
            )

        }
    }

    showAmazonShipmentEditPage = (e, shipment) => {
        let orderId = shipment.ChannelOrderID;

        let url = `https://sellercentral.amazon.co.jp/orders-v3/order/${orderId}/edit-shipment`;

        this.showConfirmClear(shipment);

        setTimeout(() => window.open(url, '_blank'), 4000);
    }

    feedTooltipTitle = (shipment) => {
        return (
            <Fragment>
                <span>Error Code: {shipment.FeedTransmitStatus.ErrorCode}</span>
                <br />
                <span>Description: {shipment.FeedTransmitStatus.ErrorDescription}</span>
            </Fragment>
        )
    }

    feedTooltipContent = (shipment) => {
        return (
            <Button>Seller Central</Button>
        )
    }

    showConfirmClear = (shipment) => {

        let _this = this

        confirm({
            title: lang.confirm_clear_shipment_feed,
            autoFocusButton: null,
            cancelText: 'No',
            okText: 'Yes, I have updated Seller Central',
            onOk() {
                _this.props.clearShipmentFeed({
                    PackageIds: [shipment.PackageID],
                })
            },
            onCancel() { },
        });
    }

    showClearButton = (shipment) => {
        if (shipment.FeedTransmitStatus && shipment.FeedTransmitStatus.FeedStatus === feedTransmitStatus.FAIL) {
            return (
                <span className='seller-central-edit'>
                    <Tooltip title='Seller Central' placement='right'>
                        <Icon type="edit" theme="outlined" onClick={(e) => this.showAmazonShipmentEditPage(e, shipment)} />
                    </Tooltip>
                </span>
            )
        }
    }
    renderPackages = () => {
        const { packages, loadingPackages, packageError } = this.state;
        // Loading state
        if (loadingPackages) {
            return (
                <tr className="package-row">
                    <td colSpan="9" style={{ padding: '30px 20px', textAlign: 'center', backgroundColor: '#f9f9f9' }}>
                        <Icon type="loading" spin style={{ fontSize: '24px', color: '#1890ff' }} />
                        <div style={{ marginTop: '10px', color: '#666' }}>Loading package information...</div>
                    </td>
                </tr>
            );
        }

        // Error state
        if (packageError) {
            return (
                <tr className="package-row">
                    <td colSpan="9" style={{ padding: '10px 20px', backgroundColor: '#fff2f0', color: '#cf1322' }}>
                        <Icon type="exclamation-circle" style={{ marginRight: '8px' }} />
                        {packageError}
                    </td>
                </tr>
            );
        }

        // No packages
        if (!packages || packages.length === 0) {
            return (
                <tr className="package-row">
                    <td colSpan="9" style={{ padding: '10px 20px', backgroundColor: '#f5f5f5', textAlign: 'center', color: '#999' }}>
                        No package information available
                    </td>
                </tr>
            );
        }
        return (
            <tr className="package-row">
                <td colSpan="9" style={{ padding: '0', backgroundColor: '#f9f9f9' }}>
                    <div style={{ padding: '15px 20px' }}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>
                            Package Information ({packages.length} package{packages.length > 1 ? 's' : ''})
                        </h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#e8e8e8' }}>
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>No</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Tracking No</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Weight</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Status</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Dimensions (L x W x H)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packages.map((pkg, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f5f5f5' }}>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{pkg.TrackingNumberCH || '-'}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            {pkg.GrossWeightFL ? `${pkg.GrossWeightFL} ${pkg.WeightUnitCH || ''}` : '-'}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            {this.renderStatusStatusID(pkg.Status)}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            {pkg.LengthFL || pkg.WidthFL || pkg.HeightFL ?
                                                `${pkg.LengthFL || '-'} x ${pkg.WidthFL || '-'} x ${pkg.HeightFL || '-'} ${pkg.LengthUnitCH || ''}`
                                                : '-'
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        );
    }

    render() {
        let styleIcon = { width: '100%', height: '100%', background: '#ffffff' }
        const {
            shipments, i, trackingNoUrl,
            listIdCheckedShipments,
            obj,
            packageInfo
        } = this.props
        let trackingHistory = shipments[i].TrackingHistorys;

        let className = shipments[i].FeedTransmitStatus && shipments[i].FeedTransmitStatus.FeedStatus === feedTransmitStatus.FAIL ? 'shipments-error' : '';
        let statusClassName = shipments[i].FeedTransmitStatus && shipments[i].FeedTransmitStatus.FeedStatus === feedTransmitStatus.FAIL ? 'shipments-error status-error' : '';
        const { expanded } = this.state;
        const hasPackages = shipments[i].Packages && shipments[i].Packages.length > 0;
        return (
            <React.Fragment>
                <tr key={i}
                // onMouseUp={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}
                // onMouseDown={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}
                >
                    <td width="2%" name='check_shipment' className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        <Checkbox
                            checked={listIdCheckedShipments.includes(shipments[i].PackageID) ? true : false}
                            onChange={() => this.props.onCheck(obj)}
                        />
                    </td>
                    <td width="10%" className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        {getImageChannel(shipments[i]['ChannelNameCH'])}
                    </td>
                    <td width="18%" name='channel_order_id' className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        <Tooltip title="Copied!" trigger='click'><span name="value">{shipments[i].ChannelOrderID}</span></Tooltip>
                    </td>
                    <td width="13%" className="tr-tool-tip-tracking-history" className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        <Tooltip
                            overlayClassName="tool-tip-tracking-history"
                            placement="topLeft"
                            autoAdjustOverflow={false}
                            title={trackingHistory && trackingHistory.length > 0 ? this.renderTrackingHistory(trackingHistory) : ''}
                        >
                            <div className="item-tracking-history">
                                {StatusActiveTrackingLink.includes(shipments[i]['StatusID']) ?
                                    <a target="_blank"
                                        rel="noopener noreferrer"
                                        href={trackingNoUrl}
                                        name='tracking_no'>{shipments[i].TrackingNumberCH}</a>
                                    : <Fragment>
                                        <Tooltip title="Copied!" trigger='click'>
                                            <span name="value">{shipments[i].TrackingNumberCH}</span>
                                        </Tooltip>
                                        {this.showClearButton(shipments[i])}
                                    </Fragment>}
                            </div>
                        </Tooltip>
                    </td>
                    <td width="10%" className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        {shipments[i].ShipDateDT ? convertDateFromUTC(shipments[i].ShipDateDT).format('MM/DD/YYYY') : ''}
                    </td>
                    <td width="10%" className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        {packageInfo}
                    </td>
                    <td width="8%" className={className} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                        {shipments[i].ConsigneeCountryCH}
                    </td>
                    <td width="13%"
                        style={{ dBreak: 'break-word' }}
                        className={className}
                        onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}
                    >
                        {shipments[i].ConsigneeNameCH}
                    </td>
                    <td width="16%" className={statusClassName}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: 1 }} onClick={(e) => this.detailShipment(e, shipments[i]['PackageID'], i)}>
                                {(shipments[i].FeedTransmitStatus && shipments[i].FeedTransmitStatus.FeedStatus === feedTransmitStatus.FAIL ? <div className="div-warning-icon"><Tooltip title={this.feedTooltipTitle(shipments[i])} placement="left" color='red'><Icon type="exclamation" theme="outlined" /></Tooltip></div> : null)}
                                {this.renderStatusShipment(shipments[i])}
                            </div>
                            {this.props.shipperInformation && this.props.shipperInformation.multiPackageFlg && (
                                <Icon
                                    type={expanded ? 'down' : 'right'}
                                    onClick={this.toggleExpand}
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        color: '#1890ff'
                                    }}
                                />
                            )}
                        </div>
                    </td>
                </tr>
                {expanded && this.renderPackages()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        shipments: state.shipmentReducer.shipments,
        listIdCheckedShipments: state.shipmentReducer.listIdCheckedShipments,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onCheck: payload => {
            dispatch(onCheck(payload))
        }, clearShipmentFeed: payload => {
            dispatch(clearShipmentFailFeed(payload))
        },
        fromQuickSearch: (payload) => {
            dispatch(fromQuickSearch(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Row)


// WEBPACK FOOTER //
// ./src/containers/shipments/list/components/row/index.js